import { apiDelete } from '../../../../core/utils/api/generic'

export const deleteThumbnail = (formUuid: string, mediaUUid: string): Promise<{ success: boolean }> =>
  apiDelete(`/media/form/${formUuid}/delete/${mediaUUid}`)

export default deleteThumbnail
